class S71DragScroll extends HTMLElement {
  constructor() {
    super();
    this.row = this.querySelector('[data-s71-drag-scroll]');
    this.hint = this.querySelector('[data-s71-scroll-hint]');
    this.thumb = this.querySelector('[data-s71-scroll-thumb]');
    this.pointerDown = this.pointerDown.bind(this);
    this.pointerMove = this.pointerMove.bind(this);
    this.pointerUp = this.pointerUp.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.updateHint = this.updateHint.bind(this);
  }

  connectedCallback() {
    if (!this.row) return;

    if (this.hint) {
      this.row.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.updateHint, { passive: true });
      this.updateHint();
    }

    if (!window.matchMedia('(pointer: fine)').matches) return;

    this.classList.add('s71-drag-scroll--enabled');
    this.row.addEventListener('pointerdown', this.pointerDown);
  }

  disconnectedCallback() {
    this.row?.removeEventListener('pointerdown', this.pointerDown);
    this.row?.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.updateHint);
    this.stop();
  }

  onScroll() {
    if (this.frame) return;

    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      this.updateHint();
    });
  }

  updateHint() {
    if (!this.hint || !this.row) return;

    const travel = this.row.scrollWidth - this.row.clientWidth;

    this.hint.hidden = travel <= 1;
    if (this.hint.hidden) return;

    const visible = this.row.clientWidth / this.row.scrollWidth;
    const progress = Math.min(1, Math.max(0, this.row.scrollLeft / travel));

    if (this.thumb) {
      this.thumb.style.width = `${(visible * 100).toFixed(2)}%`;
      this.thumb.style.transform = `translateX(${(progress * (100 / visible - 100)).toFixed(2)}%)`;
    }

    this.classList.toggle('s71-drag-scroll--scrolled', this.row.scrollLeft > 4);
  }

  pointerDown(event) {
    if (event.button !== 0) return;

    this.startX = event.clientX;
    this.startScroll = this.row.scrollLeft;
    this.moved = false;
    this.pointerId = event.pointerId;

    window.addEventListener('pointermove', this.pointerMove);
    window.addEventListener('pointerup', this.pointerUp);
    window.addEventListener('pointercancel', this.pointerUp);
  }

  pointerMove(event) {
    const delta = event.clientX - this.startX;

    if (!this.moved && Math.abs(delta) > 4) {
      this.moved = true;
      this.classList.add('s71-drag-scroll--dragging');
      this.row.setPointerCapture?.(this.pointerId);
    }

    if (!this.moved) return;
    event.preventDefault();
    this.row.scrollLeft = this.startScroll - delta;
  }

  pointerUp(event) {
    if (this.moved) {
      const swallowClick = (e) => e.preventDefault();
      this.row.addEventListener('click', swallowClick, { capture: true, once: true });
      setTimeout(() => this.row.removeEventListener('click', swallowClick, { capture: true }), 0);
      this.row.releasePointerCapture?.(event.pointerId);
    }
    this.stop();
  }

  stop() {
    this.classList.remove('s71-drag-scroll--dragging');
    window.removeEventListener('pointermove', this.pointerMove);
    window.removeEventListener('pointerup', this.pointerUp);
    window.removeEventListener('pointercancel', this.pointerUp);
  }
}

if (!customElements.get('s71-drag-scroll')) {
  customElements.define('s71-drag-scroll', S71DragScroll);
}
